import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useNavigate, useOutletContext } from "react-router-dom";

function PartnersHome() {

    const { stores } = useOutletContext(); // context에서 stores 가져오기
    console.log(stores)

    const navigate = useNavigate();

    const handleNavigateToDetail = (store) => {
        navigate(`detail/${store.id}`, {
            state: {
                storeName: store.storeName,
                // store 객체의 다른 필요한 정보들도 전달 가능
                storeInfo: store
            }
        });
    };

    const handleNavigateToManagement = (store) => {
        console.log("handleNavigateToManagement store : ", store)
        navigate(`storeManagement/${store.id}`, {
            state: {
                storeName: store.storeName,
                // store 객체의 다른 필요한 정보들도 전달 가능
                storeInfo: store
            }
        });
    };

    return (
        <Container padding={"5%"}>
            <HorizontalFlex gap={50} justifyContent={"flex-start"}>
                {stores && stores.map((store, index) => (
                    <FlexChild key={store.id} backgroundColor="white" borderRadius={10} maxWidth={"16%"}>
                        <VerticalFlex>
                            <FlexChild backgroundColor={"#46546C"} borderRadius={'10px 10px 0 0'} padding={"7%"}>
                                <P size={"1.3rem"} weight="700" color={'white'}>{store.storeName}</P>
                            </FlexChild>
                            <FlexChild padding={"10%"}> 
                                <VerticalFlex justifyContent="center" width="100%" gap={20}>
                                    <FlexChild
                                        width="fit-content"
                                        padding={"15px 40px"}
                                        border={"1px solid #46546C"}
                                        borderRadius={10}
                                        onClick={() => handleNavigateToDetail(store)}
                                        cursor={'pointer'}
                                    >
                                        <P color={'#46546C'} size={"1rem"} weight="700">매장현황</P>
                                    </FlexChild>
                                    <FlexChild width="fit-content"
                                        padding={"15px 24px"}
                                        border={"1px solid #46546C"}
                                        borderRadius={10}
                                        onClick={() => NiceModal.show("partnersRecentPaymentHistory", {
                                            storeId: store.id,
                                            storeCode: store.storeCode
                                        })}
                                        cursor="pointer"
                                    >
                                        <P color={'#46546C'} size={"1rem"} weight="700">최근 주문내역</P>
                                    </FlexChild>
                                    <FlexChild width="fit-content"
                                        padding={"15px 40px"}
                                        border={"1px solid var(--main-color)"}
                                        borderRadius={10}
                                        onClick={() => handleNavigateToManagement(store)}
                                        cursor="pointer"
                                    >
                                        <P color={"var(--main-color)"} size={"1rem"} weight="700" >상세보기</P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                ))}
            </HorizontalFlex>
        </Container>
    );
}; export default PartnersHome;